import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { retryUnlessNotFound } from "@packages/core-client/query/retryUnlessNotFound.ts";
import { useQuery } from "@tanstack/react-query";
import { useMatches } from "react-router";
import { useManagePeopleClient } from "../../../api/queries/managePeople.ts";

export function useRenderPersonDetailAsTitleOnly() {
    const matches = useMatches();
    const personId = matches[matches.length - 1]?.params?.personId ?? "";

    const { queryUtils } = useManagePeopleClient();
    const { error } = useQuery(
        createQueryOptions(queryUtils.getPerson.queryOptions({ input: { personId } }), {
            throwOnError: false,
            retry: retryUnlessNotFound
        })
    );

    return Boolean(error);
}
